import script from "./RoleFormPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./RoleFormPage.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__